import { render } from "./AdminUserTransactions.vue?vue&type=template&id=0235ce91&scoped=true"
import script from "./AdminUserTransactions.vue?vue&type=script&lang=js"
export * from "./AdminUserTransactions.vue?vue&type=script&lang=js"

import "./AdminUserTransactions.vue?vue&type=style&index=0&id=0235ce91&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0235ce91"]])

export default __exports__